"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const x_data_grid_1 = require("@mui/x-data-grid");
const Book_1 = __importDefault(require("@mui/icons-material/Book"));
const PersonSearch_1 = __importDefault(require("@mui/icons-material/PersonSearch"));
const DirectionsRun_1 = __importDefault(require("@mui/icons-material/DirectionsRun"));
const RestartAlt_1 = __importDefault(require("@mui/icons-material/RestartAlt"));
const react_router_dom_1 = require("react-router-dom");
const shared_1 = require("../shared");
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const styles_1 = require("@mui/material/styles");
const userReportApi_1 = require("../services/userReportApi");
const material_1 = require("@mui/material");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Alert = React.forwardRef(function Alert(props, ref) {
    return (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ elevation: 6, ref: ref, variant: 'filled' }, props));
});
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)((theme) => ({
    '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#424242',
        color: 'white',
    },
}));
const Users = () => {
    const [page, setPage] = React.useState(0);
    const [originalRows, setOriginalRows] = React.useState([]);
    const [rowData, setRowData] = React.useState([]);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalEnrolled, setTotalEnrolled] = React.useState(`Total Enrolled: 0`);
    const [searched, setSearched] = React.useState('');
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [userToReset, setUserToReset] = React.useState('');
    // const [selectedRowId, setSelectedRowId] = React.useState(localStorage.getItem('selectedRowId'));
    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        severity: 'success',
    });
    const navigate = (0, react_router_dom_1.useNavigate)();
    const apiRef = (0, x_data_grid_1.useGridApiRef)();
    const { data: allUsersReportData } = (0, userReportApi_1.useAllUsersReportQuery)('');
    const [reportData, setReportData] = React.useState([]);
    const [activityData, setActivityData] = React.useState([]);
    const [initLoad, setInitLoad] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const gridContainerRef = React.useRef(null);
    React.useEffect(() => {
        const savedPage = localStorage.getItem('tablePage');
        const savedRowsPerPage = localStorage.getItem('rowsPerPage');
        const savedSelectedRowId = localStorage.getItem('selectedRowId');
        if (savedPage !== null) {
            setPage(parseInt(savedPage, 10));
        }
        if (savedRowsPerPage !== null) {
            setRowsPerPage(parseInt(savedRowsPerPage, 10));
        }
        // if (savedSelectedRowId !== null) {
        //   setSelectedRowId(savedSelectedRowId);
        // }
        initGet();
    }, []);
    const handleNavigation = (route, rowId) => {
        localStorage.setItem('tablePage', page.toString());
        localStorage.setItem('selectedRowId', rowId);
        localStorage.setItem('rowsPerPage', rowsPerPage.toString());
        navigate(`/${route}/${rowId}`);
    };
    // React.useEffect(() => {
    // 	const cleanupStorage = () => {
    // 		if (!location.pathname.includes('/profile/')) {
    // 			localStorage.removeItem('tablePage');
    // 			localStorage.removeItem('selectedRowId');
    // 		}
    // 	};
    // 	return () => cleanupStorage();
    // }, [location]);
    const initGet = async () => {
        if (!initLoad) {
            const user = await (0, shared_1.getCurrentUser)();
            const admin = await (0, shared_1.checkAdminUser)(user === null || user === void 0 ? void 0 : user.email);
            if (admin) {
                setIsLoading(true);
                const [userList, regUserList, userDataArray] = await Promise.all([(0, shared_1.getAllUser)(), (0, shared_1.getAllRegisterUser)(), (0, shared_1.getAllUserDetailsData)()]);
                const finalList = (userList || []).map((obj1) => {
                    const matchingObj = (regUserList || []).find((obj2) => obj2.userId === obj1.id);
                    if (matchingObj) {
                        let count = 0, giveawayCount = 0;
                        matchingObj === null || matchingObj === void 0 ? void 0 : matchingObj.subscribedDesmos.forEach(function (sub) {
                            if ((sub === null || sub === void 0 ? void 0 : sub.ongoing) && (sub === null || sub === void 0 ? void 0 : sub.planId) != -1) {
                                count += 1;
                            }
                            if ((sub === null || sub === void 0 ? void 0 : sub.ongoing) && (sub === null || sub === void 0 ? void 0 : sub.planId) == -1) {
                                giveawayCount += 1;
                            }
                        });
                        return Object.assign(Object.assign(Object.assign({}, obj1), matchingObj), { desmosSub: count > 0 ? true : false, giveaway: giveawayCount > 0 ? true : false });
                    }
                    else {
                        return obj1;
                    }
                });
                if (finalList) {
                    setRowData(finalList);
                    setOriginalRows(finalList);
                    let totalEnroll = 0;
                    finalList.forEach((item) => {
                        var _a;
                        totalEnroll = totalEnroll + (((_a = item === null || item === void 0 ? void 0 : item.enrolledCourses) === null || _a === void 0 ? void 0 : _a.length) || 0);
                    });
                    setTotalEnrolled(`Total Enrolled: ${totalEnroll}`);
                }
                let userActivityArray = [];
                userList.forEach(async (user) => {
                    const userData = userDataArray && userDataArray.length > 0 ? userDataArray.find((item) => item.userId === user.id) || null : null;
                    let activityObj = {
                        id: user.id,
                        data: userData,
                    };
                    userActivityArray.push(activityObj);
                });
                setActivityData(userActivityArray);
                setIsLoading(false);
            }
            setInitLoad(true);
        }
    };
    React.useEffect(() => {
        if (allUsersReportData === null || allUsersReportData === void 0 ? void 0 : allUsersReportData.users) {
            const reportArray = allUsersReportData.users.map((item) => ({
                id: item.userId,
                count: item.count,
            }));
            setReportData(reportArray);
        }
    }, [allUsersReportData]);
    const handleScoreReport = (paramId) => {
        const filteredData = reportData.filter((val) => val.id === paramId);
        if (filteredData.length > 0 && filteredData[0].count > 0) {
            return 'green';
        }
        else {
            return '';
        }
    };
    const handleActivityReport = (paramId) => {
        const filteredData = activityData.filter((val) => val.id.includes(paramId));
        if (filteredData.length > 0) {
            if (filteredData[0].data != null && filteredData[0].data.activityData.length > 0) {
                return 'green';
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    };
    const columns = [
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 250,
            valueGetter: (params) => params.row.firstName,
        },
        {
            field: 'lastName',
            headerName: 'Last Name',
            width: 250,
            valueGetter: (params) => params.row.lastName,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 330,
            valueGetter: (params) => params.row.email,
        },
        {
            field: 'userId',
            headerName: 'Registered',
            width: 200,
            valueGetter: (params) => (params.row.userId && params.row.userId.length > 0 ? 'Yes' : 'No'),
        },
        {
            field: 'desmos',
            headerName: 'Desmos Subscription',
            width: 200,
            valueGetter: (params) => (params.row.desmosSub ? 'Yes' : params.row.giveaway ? 'Yes (Giveaway)' : 'No'),
        },
        {
            field: 'enrolledCourses',
            headerName: 'Enrolled Courses',
            width: 200,
            // Wrap header in a tooltip with the total enrolled count
            renderHeader: (params) => ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: totalEnrolled }, { children: (0, jsx_runtime_1.jsx)("span", { children: params.colDef.headerName }) }))),
            valueGetter: (params) => (params.row.enrolledCourses ? params.row.enrolledCourses.length : 0),
        },
        {
            field: 'studentCellNumber',
            headerName: 'Cell Number',
            width: 250,
            valueGetter: (params) => `${params.row.studentPhCode || ''} ${params.row.studentCellNumber || ''}`,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100,
            sortable: false,
            renderCell: (params) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', gap: '5px', justifyContent: 'center', width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'User Details' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'profile', onClick: () => handleNavigation('profile', params.row.id.toString()), size: 'small' }, { children: (0, jsx_runtime_1.jsx)(PersonSearch_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: 'Reset Password' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'reset', onClick: () => handleReset(params.row.email), size: 'small' }, { children: (0, jsx_runtime_1.jsx)(RestartAlt_1.default, {}) })) }))] }))),
        },
        {
            field: 'scoreReport',
            headerName: 'Score Report',
            width: 100,
            sortable: false,
            renderCell: (params) => {
                let resColor = handleScoreReport(params.row.id.toString());
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', gap: '5px', justifyContent: 'center', width: '100%' } }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: resColor === 'green' ? 'Yes' : 'No' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'score report', onClick: () => handleNavigation('reports', params.row.id.toString()), size: 'small', style: { color: resColor } }, { children: (0, jsx_runtime_1.jsx)(Book_1.default, {}) })) })) })));
            },
            valueGetter: (params) => {
                let res = handleScoreReport(params.row.id.toString());
                if (res === 'green') {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            },
        },
        {
            field: 'activityReport',
            headerName: 'Activity Report',
            width: 150,
            sortable: false,
            renderCell: (params) => {
                let resColor = handleActivityReport(params.row.id.toString());
                return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { display: 'flex', gap: '5px', justifyContent: 'center', width: '100%' } }, { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ title: resColor === 'green' ? 'Yes' : 'No' }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'extra-curricular', onClick: () => handleNavigation('excurricular-report', params.row.id.toString()), size: 'small', style: { color: resColor } }, { children: (0, jsx_runtime_1.jsx)(DirectionsRun_1.default, {}) })) })) })));
            },
            valueGetter: (params) => {
                let res = handleActivityReport(params.row.id.toString());
                if (res === 'green') {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            },
        },
    ];
    const requestSearch = (searchedVal) => {
        const filteredRows = originalRows.filter((row) => {
            var _a, _b;
            return ((_a = row === null || row === void 0 ? void 0 : row.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchedVal.toLowerCase())) || ((_b = row === null || row === void 0 ? void 0 : row.email) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchedVal.toLowerCase()));
        });
        setRowData(filteredRows);
    };
    const handleChange = (event) => {
        setSearched(event.target.value);
        setPage(0);
        requestSearch(event.target.value);
    };
    const handleReset = async (id) => {
        setUserToReset(id);
        setDialogOpen(true);
    };
    const handleDialogNo = () => {
        setUserToReset('');
        setDialogOpen(false);
    };
    const handleDialogYes = async () => {
        const url = await (0, shared_1.getMainUrl)();
        setDialogOpen(false);
        handleDeleteAfterConfirm(url);
        setUserToReset('');
    };
    const handleDeleteAfterConfirm = (url) => {
        const body = {
            email: userToReset,
            url: url,
        };
        try {
            (0, shared_1.callApi)('auth/forgotPasswordadmin', 'POST', body)
                .then((res) => {
                setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: true, message: 'Password reset mail is sent to the user successfully!', severity: 'success' }));
            })
                .catch((err) => { });
        }
        catch (error) { }
    };
    const handleSnackBarClose = () => {
        setSnackBarDetails(Object.assign(Object.assign({}, snackBarDetails), { open: false }));
    };
    // React.useEffect(() => {
    // 	function handleClickOutside(event: MouseEvent) {
    // 	  if (
    // 		gridContainerRef.current &&
    // 		!gridContainerRef.current.contains(event.target as Node)
    // 	  ) {
    // 		setSelectedRowId(null);
    // 		localStorage.removeItem('selectedRowId');
    // 	  }
    // 	}
    // 	document.addEventListener('mousedown', handleClickOutside);
    // 	return () => {
    // 	  document.removeEventListener('mousedown', handleClickOutside);
    // 	};
    //   }, [gridContainerRef]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isLoading && ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000,
                } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ style: { fontFamily: 'PoppinsMedium', fontSize: '1.5vmax', textAlign: 'center', color: 'black' } }, { children: "Please wait ..." }))] })) }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'frame-parent', ref: gridContainerRef }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'user-header-group' }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', justifyContent: 'space-between', spacing: 2, alignItems: 'center', className: 'hello-john' }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'hello-john-txt-container' }, { children: (0, jsx_runtime_1.jsx)("b", { children: "Users" }) })), (0, jsx_runtime_1.jsx)(TextField_1.default, { sx: { minWidth: '50vh' }, id: 'outlined-search', label: '', placeholder: 'Search', type: 'search', onChange: handleChange })] })) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'user-container' }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({ style: { height: '100%', width: '100%' } }, { children: (0, jsx_runtime_1.jsx)(StyledDataGrid, { apiRef: apiRef, rows: rowData, columns: columns, disableRowSelectionOnClick: true, pagination: true, slots: { toolbar: x_data_grid_1.GridToolbar }, paginationModel: { page: page, pageSize: rowsPerPage }, onPaginationModelChange: (model) => {
                                    setPage(model.page);
                                    setRowsPerPage(model.pageSize);
                                    localStorage.setItem('tablePage', model.page.toString());
                                    localStorage.setItem('rowsPerPage', model.pageSize.toString());
                                }, pageSizeOptions: [10, 25, 100], autoHeight: true, hideFooterSelectedRowCount: true, slotProps: {
                                    toolbar: {
                                        csvOptions: {
                                            fileName: 'Alphaprep-Users',
                                        },
                                    },
                                } }) })) })), (0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: dialogOpen, onClose: handleDialogNo, "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description' }, { children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, Object.assign({ id: 'alert-dialog-title' }, { children: 'Are you sure to reset password for this user?' })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: (0, jsx_runtime_1.jsx)(DialogContentText_1.default, Object.assign({ id: 'alert-dialog-description' }, { children: "You cannot undo this action" })) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: handleDialogNo }, { children: "No" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: handleDialogYes, autoFocus: true }, { children: "Yes" }))] })] })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: snackBarDetails.open, autoHideDuration: 6000, onClose: handleSnackBarClose }, { children: (0, jsx_runtime_1.jsx)(Alert, Object.assign({ onClose: handleSnackBarClose, severity: snackBarDetails.severity, sx: { width: '100%' } }, { children: snackBarDetails.message })) }))] }))] }));
};
exports.default = Users;
